"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 -0.3 14 15';

var SlidingFilters = function SlidingFilters() {
  return _react["default"].createElement("path", {
    fill: "none",
    transform: "translate(-1228, -163)",
    d: "M1230.13945,170 L1228,170 L1230.13945,170 C1230.13945,170.957008 1230.91526,171.732816 1231.87227,171.732816 C1232.82928,171.732816 1233.60508,170.957008 1233.60508,170 C1233.60508,169.042992 1232.82928,168.267184 1231.87227,168.267184 C1230.91526,168.267184 1230.13945,169.042992 1230.13945,170 L1230.23541,170 L1230.13945,170 C1230.13945,169.042992 1230.91526,168.267184 1231.87227,168.267184 C1232.82928,168.267184 1233.60508,169.042992 1233.60508,170 C1233.60508,170.957008 1232.82928,171.732816 1231.87227,171.732816 C1230.91526,171.732816 1230.13945,170.957008 1230.13945,170 Z M1239.86055,165.344598 L1239.76459,165.344598 L1242,165.344598 L1239.86055,165.344598 C1239.86055,166.301606 1239.08474,167.077414 1238.12773,167.077414 C1237.17072,167.077414 1236.39492,166.301606 1236.39492,165.344598 C1236.39492,164.38759 1237.17072,163.611782 1238.12773,163.611782 C1239.08474,163.611782 1239.86055,164.38759 1239.86055,165.344598 Z M1237.76392,174.655402 L1237.66796,174.655402 L1241.31194,174.655402 L1237.76392,174.655402 C1237.76392,175.61241 1236.98811,176.388218 1236.0311,176.388218 C1235.07409,176.388218 1234.29828,175.61241 1234.29828,174.655402 C1234.29828,173.698394 1235.07409,172.922586 1236.0311,172.922586 C1236.98811,172.922586 1237.76392,173.698394 1237.76392,174.655402 Z M1228,165.344598 L1234.66405,165.344598 L1228,165.344598 Z M1235.33595,170 L1242,170 L1235.33595,170 Z M1228,174.575827 L1232.56597,174.575827 L1228,174.575827 Z"
  });
};

var svgProps = {
  enableStroke: true,
  viewBox: viewBox
};

var _default = (0, _createSvgIcon["default"])(SlidingFilters, svgProps);

exports["default"] = _default;